enum SortOrder {
  ASC = "asc",
  DESC = "desc",
}

enum AllPageSizes {
  FIVE = 5,
  TEN = 10,
  TWENTY = 20,
  FIFTY = 50,
  HUNDERED = 100,
}

enum PageConfigDefault {
  PageSize = AllPageSizes.TEN,
  PageLimit = 1,
}

enum InputTypes {
  TEXT = "text",
  DATE = "date",
  CHECKBOX = "checkbox",
  RADIO = "radio",
  PASSOWORD = "password",
}

enum SearchFilter {
  DebounceTime = 1000, // 1 second
}

enum FileConstants {
  DownloadExpiresIn = 3600,
  DocumentLocalStorageExpiresInMinutes = 5,
  DocumentFileLocalStorageExpiresInMinutes = 10,
}

enum DocumentPageCategories {
  AUTO_DEALERS = "Auto Dealers",
  BUSINESS_SERVICES = "Business Services",
  SECURITIES = "Securities",
  UNKNOWN = "Unknown",
}

enum DocumentFileExtension {
  PDF = "application/pdf",
  TIFF = "image/tiff",
  TIF = "image/tif",
  JPG = "image/jpg",
  JPEG = "image/jpeg",
  PNG = "image/png",
}

const DocumentDivisions = [
  DocumentPageCategories.BUSINESS_SERVICES,
  DocumentPageCategories.SECURITIES,
  DocumentPageCategories.AUTO_DEALERS,
  DocumentPageCategories.UNKNOWN,
];

enum GenerativeDocumentSearchDataStorage {
  RESULTS = "gen_results",
  PAGE = "gen_page",
  SELECTED_RESULT = "gen_selected_result",
  SELECTED_PAGE = "gen_selected_page",
  SUMMARY = "gen_summary",
  NEXT_PAGE_TOKEN = "gen_next_page_token",
}

export {
  SortOrder,
  InputTypes,
  PageConfigDefault,
  AllPageSizes,
  SearchFilter,
  FileConstants,
  DocumentPageCategories,
  DocumentDivisions,
  DocumentFileExtension,
  GenerativeDocumentSearchDataStorage,
};
